const AuthBootSplash = () => (
  <div className="flex min-h-screen items-center justify-center">
    <div
      className="h-8 w-8 animate-spin rounded-full border-2 border-[#D0D5DD] border-t-[#344054]"
      aria-label="Loading session"
    />
  </div>
);

export default AuthBootSplash;
